import { setStorage, getStorage } from '../../utilities/nojq/_localstorage.js';

const isSSR = typeof window === 'undefined';

export const CASH_OFFER_CTA_SPLIT = 'movoto-dpp-cash-offer-cta-CW-4981';
export const CASH_OFFER_CTA_STORAGE_KEY = 'dpp_get_cash_offer_treatment';

/**
 * Only on/off are the experiment audience; default/control must never be stored.
 * @param {string} treatment
 */
export function persistCashOfferCtaTreatment(treatment) {
    if (isSSR) {
        return;
    }
    if (treatment === 'on' || treatment === 'off') {
        setStorage(CASH_OFFER_CTA_STORAGE_KEY, treatment);
    }
}

/**
 * on → true, off → false; omitted for users outside the experiment audience.
 * @param {object} submissionAttrs
 */
export function applyCashOfferCtaToSubmissionAttrs(submissionAttrs) {
    if (isSSR || !submissionAttrs || typeof submissionAttrs !== 'object') {
        return;
    }
    const treatment = getStorage(CASH_OFFER_CTA_STORAGE_KEY);
    if (treatment === 'on') {
        submissionAttrs.is_dpp_get_cash_offer = true;
    } else if (treatment === 'off') {
        submissionAttrs.is_dpp_get_cash_offer = false;
    }
}
